import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import GlassCard from '../components/GlassCard';
import { usePressSpring } from '../hooks/usePressSpring';
import { useLanguage } from '../i18n/LanguageContext';
import { cx } from '../utils/cx';
import mixins from '../styles/mixins.module.css';
import styles from './NotFound.module.css';

export default function NotFound() {
  const { t } = useLanguage();
  const ref = usePressSpring(mixins.pressed);

  useEffect(() => {
    document.title = '404 — OnyxUp';
  }, []);

  return (
    <section className={cx(mixins.wrap, styles.wrap)}>
      <GlassCard as="div" className={cx(mixins.card, styles.card)}>
        <div className={cx(mixins.ink, styles.code)}>404</div>
        <p className={cx(mixins.lead, styles.lead)}>{t('notFoundLead')}</p>
        <Link ref={ref} className={cx(mixins.btn, mixins.btnSolid, mixins.spring)} to="/">
          {t('notFoundBackHome')}
        </Link>
      </GlassCard>
    </section>
  );
}
